<template>
    <div class="float-left mr-2">
        <span class="text-warning">
            <i
                class="fa fa-upload fa-lg icon-button"
                title="Upload"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" @show="preencherForm()">
            <div slot="modal-title">
                Documento -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <span
                        >Movimento:
                        <strong>{{ documento.codMov }}</strong></span
                    ><br />
                    <span
                        >Tipo: <strong>{{ documento.tipo }}</strong></span
                    ><br />
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione o arquivo..."
                            ref="arquivoInput"
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvar()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import TiposMovimentosServicos from './TiposMovimentosServicos'

export default {
    props: {
        documento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'UPLOAD',
            erros: [],
            arquivo: null
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
            this.resetInserirDocumento()
        },

        resetInserirDocumento() {
            this.arquivo = null
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {},

        confirmarSalvar() {
            this.$swal({
                title: 'Documento',
                html: `Confirma o upload do documento no ${this.documento.tipo} para o movimento ${this.documento.codMov}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarDocumento()
                }
            })
        },

        salvarDocumento() {
            this.$store.dispatch('addRequest')
            let documentoDto = {
                codMov: this.documento.codMov,
                tipo: this.documento.tipo,
                arquivo: this.arquivo
            }
            TiposMovimentosServicos.inserirDocumento(documentoDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.obterDocumentosAtualizados = true
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Upload realizado com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.fecharModal()
        }
    },

    created() {},

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {},

    validations: {
        arquivo: {
            required
        }
    }
}
</script>
